
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recipes/chicken",
      function () {
        return require("private-next-pages/recipes/chicken.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recipes/chicken"])
      });
    }
  